import { Backdrop } from '../primitives/backdrop.js'
import type { FC } from 'react'
import Pulse from './pulse.js'
import styles from './fullpage-progress.module.css'

export interface FullPageProgressProps {
  show?: boolean
}

export const FullPageProgress: FC<FullPageProgressProps> = props => {
  const { show = true } = props

  return (
    <Backdrop
      open={show}
      className={styles.backdrop}
      style={{
        display: show ? 'flex' : 'none',
      }}
    >
      <Pulse size="large" />
    </Backdrop>
  )
}

export default FullPageProgress
